import React, { Component } from "react"
import { Container, Input, Row, Col, TabContent, TabPane } from "reactstrap"
import ArgyleUserList from "./ArgyleUserList"
import ArgyleNeverConnectedUserList from "./ArgyleNeverConnectedUserList"
import ActiveDriverArgyleAcccountListing from "./ActiveDriverArgyleAcccountListing"
import Select from 'react-select'
import ListingTabs from "../Material/ListingTabs"
import { ROUTES } from "../Layout/routes"
import { withPathTab } from "../Functions/usePathTab"
export const ARGYLE_LISTING_TABS = [
    { id: "connected", name: "Connected", iconClassName: "fa fa-link" },
    { id: "neverconnected", name: "Never Connected", iconClassName: "fa fa-unlink" },
    { id: "activedriverargyleaccounts", name: "Active Drivers Argle Account", iconClassName: "fa fa-car" },
]
class ArgyleUserListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: "",
            searchTerm: "",
            ongoingRefreshStatus: "enabled",
            rendererdTabPanes: [props.activeTabId],
            isActive: true
        }
    }

    componentDidUpdate(prevProps) {
        // The tab follows the URL; mount each pane on first visit and keep it mounted.
        const tabId = this.props.activeTabId
        if (prevProps.activeTabId !== tabId && !this.state.rendererdTabPanes.includes(tabId)) {
            this.setState(prevState => ({ rendererdTabPanes: [...prevState.rendererdTabPanes, tabId] }))
        }
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={ARGYLE_LISTING_TABS}
                    activeTab={this.props.activeTabId}
                    onChange={this.props.changeTab}
                />
                <br />

                <TabContent activeTab={this.props.activeTabId}>
                    {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("connected") && <TabPane tabId="connected">
                        <ArgyleUserList />
                    </TabPane>}
                    {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("neverconnected") && <TabPane tabId="neverconnected">
                        <>
                            <Row>
                                <Col xs={4}>
                                    <span className="driver-search-filter">
                                        <Input type="text" name="searchTerm" placeholder="Search by phone, email, name or license" onChange={(e) => this.setState({ searchTerm: e.target.value })} />
                                    </span>
                                </Col>
                                <Col xs={4}>
                                    <div className="pt-2">
                                        <span>Active Drivers</span>
                                        <div className="toggle-switch">
                                            <input
                                                type="checkbox"
                                                className="toggle-switch-checkbox"
                                                name={"isActive"}
                                                id={"isActive"}
                                                checked={!this.state.isActive}
                                                onChange={() => this.setState({ isActive: !this.state.isActive })}
                                            />
                                            <label className="toggle-switch-label" htmlFor={"isActive"}>
                                                <span className="toggle-switch-inner" />
                                                <span className="toggle-switch-switch" />
                                            </label>
                                        </div>
                                        <span>All Drivers</span>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <ArgyleNeverConnectedUserList searchTerm={this.state.searchTerm} isActive={this.state.isActive} />
                        </>
                    </TabPane>}
                    {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("activedriverargyleaccounts") && <TabPane tabId="activedriverargyleaccounts">
                        <>
                            <Row>
                                <Col xs={4}>
                                    <span className="driver-search-filter">
                                        <Select
                                            className="bos-custom-select" classNamePrefix="bos-select"
                                            defaultValue={[{ value: "enabled", label: "ENABLED" }]}
                                            options={[{ value: "enabled", label: "ENABLED" }, { value: "disabled", label: "DISABLED" }, { value: "idle", label: "IDLE" }]}
                                            placeholder="Select Title Owner"
                                            onChange={status => this.setState({ ongoingRefreshStatus: status.value })}
                                        />
                                    </span>
                                </Col>
                            </Row>
                            <br />
                            <ActiveDriverArgyleAcccountListing ongoingRefreshStatus={this.state.ongoingRefreshStatus} />
                        </>
                    </TabPane>}
                </TabContent>
            </Container>
        )
    }
}

export default withPathTab(ROUTES.argyle)(ArgyleUserListContainer)
